import React from 'react';

import {BaseProps} from "../../../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../../../game-center-header-module.controller";
import {GameScore, GameScoreProps} from "../../../../../../../core/components/score/game.score";
import styles from "../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
import {Countdown} from "../../../../../../../core/components/countdown/countdown";

export class GameCenterHeaderModuleDetailsStatusScoreProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleDetailsStatusScore = observer(({controller}: GameCenterHeaderModuleDetailsStatusScoreProps) => {
  const {state} = controller;
  const {device} = state;

  const {isSmallView}= device;
  const {
    homeCompetitorScoreAnimationClassName,
    awayCompetitorScoreAnimationClassName,
    isCompetitorScoreDelay,
    homeCompetitor,
    awayCompetitor,
    foulsBonusText,
    shouldDisplayTime,
    gameTimeAnimationClassName,
    shouldRenderPossession
  } = state;


  const gameScore: GameScoreProps = {
    className: classNames(styles.score),
    dividerClassName: classNames(styles.score_divider),
    homeCompetitorScoreClassName: classNames(homeCompetitorScoreAnimationClassName),
    awayCompetitorScoreClassName: classNames(awayCompetitorScoreAnimationClassName),
    // competitorScoreContainerClassName: classNames(styles.bonus_score),
    delay: isCompetitorScoreDelay,
    homeCompetitor: homeCompetitor,
    awayCompetitor: awayCompetitor,
    foulsBonusText: foulsBonusText,
    isSmallView: isSmallView,
    shouldRenderPossession
  };

  const gameTime: GameScoreProps = {
    className: gameTimeAnimationClassName,
    isSmallView: device.isSmallView,
    game: state,
  }

  return (
    shouldDisplayTime ? <Countdown {...gameTime}/> : <GameScore {...gameScore}/>
  )
});
